import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../core/toast.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('sp_token');
  const router = inject(Router);
  const toast = inject(ToastService);
  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;
  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 && !req.url.includes('/auth/login')) {
        localStorage.removeItem('sp_token');
        localStorage.removeItem('sp_user');
        toast.error('Session expired — please log in again');
        router.navigate(['/login']);
      } else if (err.status >= 500) {
        toast.error('Something went wrong — please try again');
      } else if (err.status === 0) {
        toast.error('Network error — check your internet connection');
      }
      return throwError(() => err);
    })
  );
};
